var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPagesIcon = function SvgPagesIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 25 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    clipPath: "url(#pagesIcon_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.95 23.581V.5h13.554a.5.5 0 0 1 .386.182l5.28 6.403a.5.5 0 0 1 .114.32l-.06 16.176H2.952Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillOpacity: 0.25,
    strokeWidth: 0.72,
    d: "m16.974 7.481 4.28-.116a.46.46 0 0 0 .341-.754L16.904.981a.46.46 0 0 0-.813.295v5.345c0 .484.4.873.883.86Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "pagesIcon_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M.45 0h24v24h-24z"
  })))));
};
export { SvgPagesIcon as ReactComponent };